import { Injectable } from '@angular/core';
import { TrackingService } from './tracking.service';
import {
  TrackingClickToggleParams,
  TrackingLoginSignupParams,
  TrackingPageViewAbandonParams,
  TrackingPageViewParams,
  TrackingPageName
} from '../../interfaces/tracking.interfaces';

@Injectable({
  providedIn: 'root'
})
export class TrackingNewService {
  // Data Layer is initialised in the TrackingService, so in order to maintain one `dataLayer`
  // object we temporarily use the new tracking method `trackEventNew` from GtmTracking service
  // through the TrackingService.
  //
  // TODO: when all events are migrated to new versions, old TrackingService should be replaced
  // with this one, and initialisation of `dataLayer` should also be moved here.
  constructor(private readonly trackingService: TrackingService) {}

  /**
   * Track click events on the all clickable elements, e.g. button, link, section.
   */
  trackClickEvent(eventDetails: TrackingClickToggleParams): void {
    this.trackingService.gtmTracking.trackEventNew({ event: 'lh_click_element', eventDetails });
  }

  /**
   * Track toggle events on the all toggable elements, e.g. checkbox, dialog, popover.
   */
  trackToggleEvent(eventDetails: TrackingClickToggleParams): void {
    this.trackingService.gtmTracking.trackEventNew({ event: 'lh_toggle_element', eventDetails });
  }

  /**
   * Track login event upon user login.
   */
  trackLoginEvent(eventDetails: TrackingLoginSignupParams): void {
    this.trackingService.gtmTracking.trackEventNew({ event: 'lh_login', eventDetails });
  }

  /**
   * Track signup event upon user signup.
   */
  trackSignupEvent(eventDetails: TrackingLoginSignupParams): void {
    this.trackingService.gtmTracking.trackEventNew({ event: 'lh_signup', eventDetails });
  }

  /**
   * Track page view events for all pages.
   */
  trackViewPageEvent(eventDetails: TrackingPageViewParams): void {
    this.trackingService.gtmTracking.trackEventNew({ event: 'lh_view_page', eventDetails });
  }

  /**
   * Track page abandonment event.
   */
  trackPageAbandonmentEvent(eventDetails: TrackingPageViewAbandonParams): void {
    this.trackingService.gtmTracking.trackEventNew({ event: 'lh_abandon_page', eventDetails });
  }

  getTrackingPageName(routerUrl): TrackingPageName {
    switch (routerUrl) {
      case routerUrl.includes('listings/properties'):
        return 'listings';
      case routerUrl.includes('suites'):
        return 'product_details';
      case routerUrl.includes('listings/checkout'):
        return 'checkout';
      case routerUrl.includes('our-locations'):
        return 'locations';
      default:
        return routerUrl;
    }
  }
}
